import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../commonComponents/translate';
import StatusLabel from '../../../../../commonComponents/StatusLabel';
import FileUploadBtn from '../../../../../commonComponents/forms/FileUploadBtn';
import {
  compose,
  JOURNEY_TASK_STATUS,
} from '../../../../../services/utilityFunctions';
import withCSRF from '../../../../../commonComponents/withCSRF';

const PdfInfoSection = ({
  t,
  _csrf,
  title,
  maxDays,
  description,
  onUploadPdf,
  onLoading,
  isLoading,
  status,
  customOnClick,
  isFillAndSign,
  onRedoPDF,
  showSubmitButton,
  showRedoButton,
}) => {
  const isStatusPending = status === JOURNEY_TASK_STATUS.PENDING;
  const isStatusApproved = status === JOURNEY_TASK_STATUS.APPROVED;

  const sectionTitle = isFillAndSign
    ? t('journey.step.fill.title')
    : t('journey.step.pdf.title');
  const buttonLabel = isFillAndSign
    ? t('journey.step.fill.upload')
    : t('journey.step.pdf.title');

  return (
    <div className="m-portlet m-portlet-rounded">
      <div id="infoContainer" className="m-portlet__body">
        <span className="title">{sectionTitle}</span>
        {title && <span className="pdf-name">{title}</span>}
        {maxDays && (
          <span className="max-days">{t('number.days', maxDays)}</span>
        )}
        {!isFillAndSign
          ? isStatusPending && <StatusLabel />
          : status && <StatusLabel status={status} />}
        {!isStatusApproved && showSubmitButton && (
          <div className="file-upload-button">
            <FileUploadBtn
              label={buttonLabel}
              onLoading={onLoading}
              handleFile={onUploadPdf}
              isLoading={isLoading}
              customOnClick={customOnClick}
              _csrf={_csrf}
            />
          </div>
        )}
        {showRedoButton ? (
          <button
            type="button"
            onClick={onRedoPDF}
            className="btn btn-dynamic btn-sm m-btn--pill btn-file redo-button"
          >
            {t('redo.pdf')}
            <i className="fa fa-file-signature" />
          </button>
        ) : null}
        {description && <span className="description">{description}</span>}
      </div>
    </div>
  );
};

PdfInfoSection.propTypes = {
  _csrf: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  maxDays: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  onUploadPdf: PropTypes.func.isRequired,
  customOnClick: PropTypes.func.isRequired,
  onLoading: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  status: PropTypes.string.isRequired,
  isFillAndSign: PropTypes.bool,
  onRedoPDF: PropTypes.func,
  showSubmitButton: PropTypes.bool,
  showRedoButton: PropTypes.bool,
};

PdfInfoSection.defaultProps = {
  isFillAndSign: false,
  onRedoPDF: null,
  showSubmitButton: true,
  showRedoButton: false,
};
export default compose(translate, withCSRF)(PdfInfoSection);
